import type { QuestionItem as QuestionItemType, AnswerValue } from '@/types/questionnaire';
import SelectQuestion from './SelectQuestion';
import TextareaQuestion from './TextareaQuestion';

interface QuestionItemProps {
  question: QuestionItemType;
  value?: AnswerValue;
  error?: string;
  readOnly?: boolean;
  onChange?: (value: AnswerValue) => void;
}

const QuestionItemComponent = ({
  question,
  value,
  error,
  readOnly = false,
  onChange,
}: QuestionItemProps) => {
  const { title, description, type, required, validation } = question;
  const isRequired = validation?.required ?? required ?? false;

  // 渲染问题内容
  const renderQuestionContent = () => {
    switch (type) {
      case 'select':
        return (
          <SelectQuestion
            question={question}
            value={value}
            readOnly={readOnly}
            onChange={onChange}
          />
        );
      case 'textarea':
        return (
          <TextareaQuestion
            question={question}
            value={value}
            readOnly={readOnly}
            onChange={onChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      {/* 问题标题 */}
      <div className="mb-3">
        <h3 className="text-base font-semibold text-slate-900 flex items-center gap-2">
          <span>{title}</span>
          {isRequired && <span className="text-red-500">*</span>}
        </h3>
        {description && <p className="text-sm text-slate-500 mt-1">{description}</p>}
      </div>

      {/* 问题输入区域 */}
      <div className="mb-2">{renderQuestionContent()}</div>

      {/* 错误信息 */}
      {error && <div className="text-sm text-red-600 mt-1">{error}</div>}
    </div>
  );
};

export default QuestionItemComponent;
